import kalapostAPI, { getErrorType } from "./httpService";
import _ from "lodash";

export const getStatesPostService = async (stateId) => {
   try {
      return await kalapostAPI.get("selectorPostOffice", { params: { stateId } });
   } catch (error) {
      return getErrorType(error);
   }
};
export const getCitiesPostService = async (stateId, cityId) => {
   try {
      return await kalapostAPI.get("selectorPostOffice", { params: { stateId, cityId } });
   } catch (error) {
      return getErrorType(error);
   }
};
export const uploadLogoService = async (data, ProgressEvent) => {
   try {
      return await kalapostAPI.post("file", data, {
         onUploadProgress: ProgressEvent,
         headers: { "Content-Type": "multipart/form-data" },
      });
   } catch (error) {
      return getErrorType(error);
   }
};

export const registerStoreService = async (data, token) => {
   try {
      return await kalapostAPI.post(
         "request", data,
         { headers: { "g-recaptcha-response": token } }
      );
   } catch (error) {
      return getErrorType(error);
   }
};